import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const BillingCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#fdfaf6] flex items-center justify-center px-5">
      <div className="max-w-md w-full bg-white rounded-3xl border border-slate-200 shadow-xl p-10 text-center">
        <div className="w-16 h-16 mx-auto rounded-full bg-slate-100 flex items-center justify-center">
          <XCircle className="w-9 h-9 text-slate-500" />
        </div>
        <h1 className="mt-5 text-2xl font-extrabold text-slate-900">Checkout cancelled</h1>
        <p className="mt-1 text-slate-600">No worries — your account is unchanged. Pick a plan whenever you're ready.</p>
        <div className="mt-6 flex gap-2 justify-center">
          <Button variant="outline" onClick={() => navigate('/dashboard')}>Dashboard</Button>
          <Button onClick={() => navigate('/#pricing')} className="bg-slate-900 hover:bg-slate-800 text-white">View plans</Button>
        </div>
      </div>
    </div>
  );
};

export default BillingCancel;
